import React from "react";
import { CardContent } from "@mui/material";
import { LocationCard } from "../styles/mapStyles";
import LocationCardHeader from "./LocationCardHeader";
import ComponentSelectionForm from "./ComponentSelectionForm";
import CardActionButtons from "./CardActionButtons";

const LocationDetailsCard = ({
  selectedLocation,
  selectedComponent,
  selectionType,
  selectedRadius,
  isEditMode,
  myComponents,
  onCancel,
  onComponentChange,
  onSelectionTypeChange,
  onRadiusChange,
  onDelete,
  onUpdate,
  onAccept,
  t,
}) => {
  return (
    <LocationCard>
      <CardContent>
        <LocationCardHeader
          selectedLocation={selectedLocation}
          selectedComponent={selectedComponent}
          onCancel={onCancel}
          t={t}
        />

        <ComponentSelectionForm
          selectionType={selectionType}
          onSelectionTypeChange={onSelectionTypeChange}
          selectedComponent={selectedComponent}
          onComponentChange={onComponentChange}
          selectedRadius={selectedRadius}
          onRadiusChange={onRadiusChange}
          myComponents={myComponents}
          t={t}
        />
      </CardContent>

      <CardActionButtons
        isEditMode={isEditMode}
        onDelete={onDelete}
        onUpdate={onUpdate}
        onCancel={onCancel}
        onAccept={onAccept}
        t={t}
      />
    </LocationCard>
  );
};

export default LocationDetailsCard;
